import { render, staticRenderFns } from "./AssignmentFeedback.vue?vue&type=template&id=a173d72e&scoped=true&"
import script from "./AssignmentFeedback.vue?vue&type=script&lang=js&"
export * from "./AssignmentFeedback.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentFeedback.vue?vue&type=style&index=0&id=a173d72e&prod&lang=css&"
import style1 from "./AssignmentFeedback.vue?vue&type=style&index=1&id=a173d72e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a173d72e",
  null
  
)

export default component.exports